const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const config = {
  backendUrl: isDevelopment 
    ? 'http://127.0.0.1:8000'
    : 'https://backend-dot-woven-nova-430315-k7.nn.r.appspot.com',
};

export default config; 